import React from 'react';
import GameQuery from '../../query/GameQuery';
import Inbox from '../../components/Inbox';
import { Route } from 'react-router-dom';
import { INBOX } from '../../routes';

const InboxRoute = () => 
	<GameQuery>
		<Route path={INBOX} component={Inbox} />
	</GameQuery>
;

export default InboxRoute;
